import React, { createContext, useContext, useEffect, useState } from 'react';
import { Modal } from '@mui/material';

export const DialogLayer = createContext<React.RefObject<HTMLElement> | null>(
  null,
);

interface Props {
  label?: string;
  labelledBy?: string;
  panelClassName: string;
  onClose: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  initialFocus?: React.RefObject<HTMLElement>;
  children: React.ReactNode;
}

const ScreeningDialog: React.FC<Props> = ({
  label,
  labelledBy,
  panelClassName,
  onClose,
  onKeyDown,
  initialFocus,
  children,
}) => {
  const layer = useContext(DialogLayer);
  const [panel, setPanel] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (panel) {
      (initialFocus?.current || panel).focus();
    }
  }, [panel]);

  return (
    <Modal
      open
      onClose={onClose}
      container={() => layer?.current || document.body}
      hideBackdrop
      disableAutoFocus
    >
      <div className='psc-layer' tabIndex={-1} onKeyDown={onKeyDown}>
        <div className='psc-scrim' onClick={onClose} aria-hidden='true' />
        <div
          ref={setPanel}
          className={panelClassName}
          role='dialog'
          aria-modal='true'
          aria-label={label}
          aria-labelledby={labelledBy}
          tabIndex={-1}
        >
          {children}
        </div>
      </div>
    </Modal>
  );
};

export default ScreeningDialog;
